import { render, staticRenderFns } from "./search-history.vue?vue&type=template&id=3e62654a&"
import script from "./search-history.vue?vue&type=script&lang=js&"
export * from "./search-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports